(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cw-scroll-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=document.documentElement;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const compact=matchMedia('(max-width: 749px)');
  let headings=[],pending=false;
  function paint(){
    pending=false;
    const button=document.querySelector('.cw-return-top');
    if(!button)return;
    const distance=Math.max(0,root.scrollHeight-innerHeight);
    button.hidden=scrollY<Math.min(360,innerHeight*.6);
    button.style.setProperty('--cw-page-progress',String(distance?Math.max(0,Math.min(100,scrollY/distance*100)):0));
    const stopped=reduced.matches||compact.matches||root.classList.contains('motion-paused')||window.Shopify?.designMode;
    headings.forEach(el=>{
      const rect=el.getBoundingClientRect();
      const old=parseFloat(el.style.getPropertyValue('--cw-heading-offset'))||0;
      const y=rect.top-old;
      if(stopped)el.style.setProperty('--cw-heading-offset','0px');
      else if(y<innerHeight+100&&y+rect.height> -100)el.style.setProperty('--cw-heading-offset',Math.max(-24,Math.min(24,(y+rect.height/2-innerHeight/2)*.065))+'px');
    });
  }
  function schedule(){if(!pending){pending=true;requestAnimationFrame(paint)}}
  function init(){
    headings=[...document.querySelectorAll('main h2')].filter(el=>!el.closest('dialog,.world-portal,.collab-campaign,[data-product-form],.product-form,.product__details'));
    headings.forEach(el=>el.classList.add('cw-scroll-heading'));
    const button=document.querySelector('.cw-return-top');
    if(button)button.onclick=()=>{
      const main=document.getElementById('main');
      if(main){if(!main.hasAttribute('tabindex'))main.setAttribute('tabindex','-1');main.focus({preventScroll:true})}
      window.scrollTo({top:0,behavior:reduced.matches||root.classList.contains('motion-paused')?'instant':'smooth'});
    };
    schedule();
  }
  new MutationObserver(schedule).observe(root,{attributes:true,attributeFilter:['class']});
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  reduced.addEventListener('change',schedule);
  compact.addEventListener('change',schedule);
  if('ResizeObserver' in window)new ResizeObserver(schedule).observe(document.body);
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
  } catch(e) { console.error(e); }
})();

})();
